import React from "react";
import "./YzyPlayButton.scss";

export default function YzyPlayButton( {onClick, className}:{onClick:React.MouseEventHandler, className:string}) {
    return <button onClick={onClick} className={"YzyPlayButton "+(className||"")} aria-label={"play with yzy"}>
        <img src={"images/yzy-spinner.svg"} width={32} height={32} alt="yzy spinner"/>
    </button>
}